$('.review_slider').slick({
    fade: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   dots: false,
   prevArrow: '<button class="slide-arrow slick-prev"><svg width="25" height="67" viewBox="0 0 25 67" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 2L3 33.1379L23 65" stroke="%2354C0E8" stroke-width="4"/></svg></button>',
   nextArrow: '<button class="slide-arrow slick-next"><svg width="25" height="67" viewBox="0 0 25 67" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 65L22 33.8621L2 2" stroke="%2354C0E8" stroke-width="4"/></svg></button>',
  infinite: true,
  adaptiveHeight: true
 });
//
$(document).ready(function(){
  $('.banner-slider_section').slick({
    fade: false,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots:true,
    arrows: false,
    infinite: true,
    centerMode: false      
  });
});

jQuery('.product-slider-activation').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  autoplay: true,
    autoplaySpeed: 2000
});

// onClick new options list of new select
$('.product-detail .ae-select-content').text($('.dropdown-menu > li.selected').text());
//$('.slider-product-contents .ae-select-content').text($('.dropdown-menu > li.selected').text());

$('.product-slider-wrapper .ae-dropdown.dropdown').each(function () { 
	var rrr = $(this).find('ul.dropdown-menu li.selected');
	var value = rrr.text();
	$(this).find('span.ae-select-content').text(value);
});


var newOptions = $('.dropdown-menu > li');
		newOptions.click(function() {
      $('.ae-select-content').text($(this).text());
      $('.dropdown-menu > li').removeClass('selected');
      $(this).addClass('selected');
		});

var aeDropdown = $('.ae-dropdown');
		aeDropdown.click(function() {
      $('.dropdown-menu').toggleClass('ae-hide');
		});


$(document).on("click", function(event){
        var $trigger = $(".dropdown");
        if($trigger !== event.target && !$trigger.has(event.target).length){
            $('.dropdown-menu').addClass('ae-hide');
        }            
    });


$('.product-detail .ae-select-content-qty').text($('.dropdown-menu-qty > li.selected').text());
$('.product-slider-wrapper .ae-dropdown-qty.dropdown-qty').each(function () { 
	var rrr = $(this).find('ul.dropdown-menu-qty li.selected');
	var value = rrr.text();
	$(this).find('span.ae-select-content-qty').text(value);
});
var newOptionsQty = $('.dropdown-menu-qty > li');
		newOptionsQty.click(function() {
      $('.ae-select-content-qty').text($(this).text());
      $('.dropdown-menu-qty > li').removeClass('selected');
      $(this).addClass('selected');
		});

var aeDropdownQty = $('.ae-dropdown-qty');
		aeDropdownQty.click(function() {
      $('.dropdown-menu-qty').toggleClass('ae-hide');
		});


$(document).on("click", function(event){
        var $triggerQty = $(".dropdown-qty");
        if($triggerQty !== event.target && !$triggerQty.has(event.target).length){
            $('.dropdown-menu-qty').addClass('ae-hide');
        }            
    });


// quantity plus and minus
$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 

// Ajax Add t cart
$('#add-to-cart-form').on('submit', function(event) {
  event.preventDefault(); // prevent default form submission
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(this).serialize(),
    dataType: 'json',
    success: function() {
      // Do something on success (e.g. show a success message)
    },
    error: function() {
      // Do something on error (e.g. show an error message)
    }
  });
});

  $(document).ready(function(){
    $('ul.shopify-tabs > li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $(this).parent().find('li').removeClass('current');
      $('.shopify-tab-content').removeClass('current');

      $(this).addClass('current');

      $("#"+tab_id).addClass('current');

    });

  });

jQuery(".stamped-product-reviews-badge").click(function(){
   jQuery(".shopify-tabs li[data-tab='tab-review']").trigger("click");
   jQuery('html, body').animate({
      scrollTop: jQuery(".custom-tabs").offset().top
  }, 1000);
   return false;   
});

